module.exports = __webpack_public_path__ + "static/media/information.2508df20.svg";